/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  createAsyncIterable,
  TransformStream,
  toPolyfillReadable,
  intoStandardStream,
  isToolCallAssistantMessage,
} from '../../utils'
import type { ArkGenerateTextOutput, ArkInputData, ArkStreamTextOutput } from './type'
import type {
  ModelReq,
  BaseChatModelInput,
  SimpleChatModel,
  DoGenerateOutput,
  DoStreamOutput,
  BaseDoStreamOutputChunk,
  ReqOptions,
} from '../../type'

function processInput(input: BaseChatModelInput): ArkInputData {
  const { messages, model, temperature, tools, top_p } = input

  return {
    ...input,
    messages,
    model,
    tools,
    top_p,
    temperature,
  }
}

export class ArkSimpleModel implements SimpleChatModel {
  public subUrl = 'ark/api/v3/chat/completions'
  constructor(private req: ModelReq, public baseUrl: string, subUrl?: string) {
    if (subUrl != null) {
      this.subUrl = subUrl
    }
  }

  private get url() {
    return `${this.baseUrl}/${this.subUrl}`
  }

  public async doGenerate(data: BaseChatModelInput, options?: ReqOptions): Promise<DoGenerateOutput> {
    const res = (await this.req({
      url: this.url,
      data: {
        ...processInput(data),
        stream: false,
      },
      stream: false,
      timeout: options?.timeout,
    })) as ArkGenerateTextOutput
    return { ...res, rawResponse: res }
  }

  public async doStream(data: BaseChatModelInput, options?: ReqOptions): Promise<DoStreamOutput> {
    let isToolCall: null | boolean = null
    const _stream = await this.req({
      url: this.url,
      data: {
        ...processInput(data),
        stream: true,
      },
      stream: true,
      timeout: options?.timeout,
    })
    const stream = toPolyfillReadable(_stream) as typeof _stream

    const arkStream = intoStandardStream<ArkStreamTextOutput>(stream)
    const streamWithRaw = arkStream.pipeThrough(new TransformStream<ArkStreamTextOutput, BaseDoStreamOutputChunk & { rawResponse?: any }>({
      transform(chunk, controller) {
        const newChoices = chunk.choices.map((choice) => {
          const message = choice.delta
          if (isToolCall == null) isToolCall = isToolCallAssistantMessage(message)
          if (isToolCall) {
            return {
              ...choice,
              finish_reason: 'tool_calls' as const,
              delta: message,
            }
          }
          return choice
        })
        const newChunk = { ...chunk, choices: newChoices }
        controller.enqueue({ ...newChunk, rawResponse: chunk })
      },
    }),)

    return createAsyncIterable(streamWithRaw)
  }
}
